import React from 'react';
import { Button, Banner } from '@redshelf/redshelf-ui';

import { ROUTER } from 'constants';

const Error403 = () => {
  return (
    <Banner
      title="Sorry, you can’t access this page."
      message={
        <React.Fragment>
          You may need to be logged in, or your account may not have permission
          to access the page. If you think you’ve received this message in
          error,{' '}
          <a
            rel="noreferrer"
            target="_blank"
            href="https://solve.redshelf.com/hc/en-us/requests/new?ticket_form_id=360000291393"
          >
            please let us know so we can investigate it.
          </a>
        </React.Fragment>
      }
      action={
        <Button routerLink to={ROUTER.basename}>
          Back to Campus Insights
        </Button>
      }
    />
  );
};

export default Error403;
